import { render } from "./Column1.vue?vue&type=template&id=366713f8"
import script from "./Column1.vue?vue&type=script&lang=js"
export * from "./Column1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__